import { Button } from "@sum-video/shared/components/ui/button";
import type { User } from "@supabase/supabase-js";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";

interface DesktopNavProps {
  t: (key: string) => string;
  user: User | null;
  isSubscribed: boolean;
}

export function DesktopNav({ t, user, isSubscribed }: DesktopNavProps) {
  const sectionsT = useTranslations("BlogSections");
  return (
    <nav className="hidden md:flex items-center space-x-6">
      <Button variant="ghost" size="sm" asChild>
        <Link href="/how-it-works">{t("howItWorks")}</Link>
      </Button>
      <Button variant="ghost" size="sm" asChild>
        <Link href="/guides">{sectionsT("guides.name")}</Link>
      </Button>
      <Button variant="ghost" size="sm" asChild>
        <Link href="/comparisons">{sectionsT("comparisons.name")}</Link>
      </Button>
      <Button variant="ghost" size="sm" asChild>
        <Link href="/affiliate">{t("affiliate")}</Link>
      </Button>
      {(!user || !isSubscribed) && (
        <Button variant="ghost" size="sm" asChild>
          <Link href="/pricing">{t("pricing")}</Link>
        </Button>
      )}
    </nav>
  );
}
